<div class="my-overlay" *ngIf="showOverlay">
    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> <br>
    <h3 style="text-align: center; color: white">Please wait ...</h3>
  
</div>
<style type="text/css">.my-overlay {
    left: 0 !important;
    top: 0 !important;
    z-index: 10000 !important;
    width: 100% !important;
    height: 100% !important;
    position: fixed !important;
    background-color: rgba(0,0,0,0.9) !important;
    cursor: pointer !important;
    visibility: visible !important;
    transition: visibility 0s, opacity 0.4s linear !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: wait !important;
}
.my-overlay i.fa.fa-spinner.fa-spin, .spinner-big {
    font-size: 100px !important;
}</style>
<div class="main-content">
    <div class="container-fluid">
       
        <div class="clearfix"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card/-header-primary card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">assignment</i>
                        </div>
                        <h4 class="card-title">Synced Items</h4>
                        <div class="toolbar">
                            <!--        Here you can write extra buttons/actions for the toolbar              -->
                             <div class="col-md-12">
                  
                  <button (click)="goExport('status','unpublish')" style="float: right;" mat-raised-button class="btn btn-danger">Unpublish ({{arrayExport.length}})</button>

                  <button (click)="goExport('status','published')" style="float: right;" mat-raised-button class="btn btn-success">Publish ({{arrayExport.length}})</button>

                  <button (click)="openHotDealModal()" style="float: right;" mat-raised-button class="btn btn-info"><span style="color: indianred" class="material-icons">
whatshot
</span>
 Set Hot Deal ({{arrayExport.length}})</button>
                  <button (click)="setHotDeal(0)" style="float: right;" mat-raised-button class="btn btn-info"><span style="color: indianred" class="material-icons">
whatshot
</span> Unset Hot Deal ({{arrayExport.length}})</button>
                </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div *ngIf="loadingTable" style="text-align: center">
                            <br>
                            <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
                        </div>
                        <div class="material-datatables">
                            <table id="datatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox" name="select_all" value="1" id="example-select-all"></th>
                                        <th>{{ dataTable.headerRow[0] }}</th>
                                        <th>{{ dataTable.headerRow[1] }}</th>
                                        <th>{{ dataTable.headerRow[2] }}</th>
                                        <th>{{ dataTable.headerRow[3] }}</th>
                                        <th>Percentage</th>
                                        <th>Stock</th>
                                        <th>WU</th>
                                        <th>Published</th>
                                        <th>Days published</th>
                                        <th>{{ dataTable.headerRow[4] }}</th>
                                       
                                        <th class="disabled-sorting text-right">{{ dataTable.headerRow[5] }}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr id="user{{row[0]}}" *ngFor="let row of dataTable.dataRows">
                                         <td ><input id="{{row[0]}}" type="checkbox" name="id[]" value=""></td>
                                        <td>{{row[0]}}</td>
                                        <td><img style="width: 100px;" src="{{row[1]}}"> </td>
                                        <td><span alt="hot" *ngIf="row[10] == 1" style="color: indianred" class="material-icons">
whatshot
</span> {{row[2]}}</td>
                                        <td>
                                            <span *ngIf="editPrice != row[0]">
                                                <button (click)="editarPrice(row[0], row[3])" class="btn btn-link btn-primary btn-just-icon" [disabled]="editPrice !== null">
                                                    <i class="material-icons">mode</i>
                                                </button> &nbsp; $ {{row[3]}}
                                            </span>
                                            <span class="bmd-form-group" *ngIf="editPrice == row[0]">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <button (click)="cancelEditPrice()" class="btn btn-link btn-primary btn-just-icon" [disabled]="savingPrice === row[0]"><i class="material-icons">close</i></button>
                                                    </div>
                                                    <input type="number" name="Price" [(ngModel)]="tmpPrice" (keyup.enter)="saveStock()" style="width: 90px;">
                                                    <div class="input-group-prepend">
                                                        <button *ngIf="savingPrice === null" (click)="savePrice()" class="btn btn-link btn-primary btn-just-icon">
                                                            <i class="material-icons">save</i>
                                                        </button>
                                                        <button *ngIf="savingPrice === row[0]" class="btn btn-link btn-default btn-just-icon" disabled>
                                                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </span>
                                        </td>
                                        <td>  
                                          {{row[12]}}
                                        </td>
                                        <td>
                                            <span *ngIf="editStock != row[0]">
                                                <button (click)="editarStock(row[0], row[7])" class="btn btn-link btn-primary btn-just-icon" [disabled]="editStock !== null">
                                                    <i class="material-icons">mode</i>
                                                </button> &nbsp; {{row[7]}}
                                            </span>
                                            <span class="bmd-form-group" *ngIf="editStock == row[0]">
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <button (click)="cancelEditStock()" class="btn btn-link btn-primary btn-just-icon" [disabled]="savingStock === row[0]"><i class="material-icons">close</i></button>
                                                    </div>
                                                    <input (keypress)="mtds.onlyNumber($event)" type="number" name="Stock" [(ngModel)]="tmpStock" (keyup.enter)="saveStock()" style="width: 90px;">
                                                    <div class="input-group-prepend">
                                                        <button *ngIf="savingStock === null" (click)="saveStock()" class="btn btn-link btn-primary btn-just-icon">
                                                            <i class="material-icons">save</i>
                                                        </button>
                                                        <button *ngIf="savingStock === row[0]" class="btn btn-link btn-default btn-just-icon" disabled>
                                                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </span>
                                        </td>
                                        <td>
                                            <button (click)="wu(row[9])" class="btn btn-link btn-warning btn-just-icon">
                                                <i class="material-icons">groups</i>
                                            </button>
                                        </td>
                                        <td>
                                            {{row[11] | date}}
                                        </td>
                                        <td>
                                            {{row[11] | Longago}}
                                        </td>
                                        <td>
                                            <button *ngIf="row[4] == 'Published'" class="btn btn-success">Published</button>
                                            <button *ngIf="row[4] == 'No Published'" class="btn btn-danger">No Published</button>
                                        </td>

                                        <td style="display: initial;" class="">
                                            <a [href]="row[5]" *ngIf="row[4] == 'Published'" target="_blank"><button style="text-transform: capitalize;" class="btn btn-info"> See at Store</button></a>

                                            <a [href]="row[6]" target="_blank"><button style="text-transform: capitalize;" class="btn btn-info">See at Ebay</button></a>

                                            <a (click)="deleteItem(row[0])" class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <input type="hidden" name="borrarUser" value="" id="borrarUser" (click)="deleteUser()">
                        </div>
                        <nav aria-label="...">
                        <div style="display: inline-flex; width: 100%; position: relative;">
                          <mat-form-field style="max-width: 90px">
                            <mat-select (selectionChange)="changeLimit()" placeholder="Showing"
                              [(ngModel)]="itemsPerPageSelected" ariaLabel="itemsPerPageSelected">
                              <mat-option value="5">5</mat-option>
                              <mat-option value="10">10</mat-option>
                              <mat-option value="25">25</mat-option>
                              <mat-option value="50">50</mat-option>
                              <mat-option value="100">100</mat-option>
                              <mat-option value="200">200</mat-option>
                              <mat-option value="500">500</mat-option>
                              <mat-option value="1000">1000</mat-option>
                              <mat-option value="ALL">ALL</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <p style="align-self: flex-end; margin-left: 30%;">
                            Showing {{this.showingNav}} to {{this.showingTo}} of {{this.totalItemsCount }} entries
                          </p>
                          <ul class="pagination" style="position: absolute; right: 0;">
                            <div style="display: flex;">
                                <li class="page-item">
                                    <a [routerLink]="['/tables/listebayitems', 1]" *ngIf="actualPage > 1" class="page-link" tabindex="-1">First</a>
                                </li>
                              <li class="page-item">
                                <a [routerLink]="['/tables/listebayitems', pagePrev]" class="page-link" href="#"
                                  tabindex="-1">Previous</a>
                              </li>
                              <li *ngFor="let page of pages" class="page-item"><a
                                  [className]="this.actualPage == page+1 ? 'selected-page' : 'page-link'"
                                  [routerLink]="['/tables/listebayitems', page+1]">{{page+1}}</a></li>
                              <li class="page-item">
                                <a class="page-link" [routerLink]="['/tables/listebayitems', pageNext]">Next</a>
                              </li>
                                <li class="page-item">
                                  <a [routerLink]="['/tables/listebayitems', total_pages]" *ngIf="actualPage < total_pages" class="page-link" tabindex="-1">Last</a>
                                </li>
                            </div>
                          </ul>
                        </div>
                      </nav>
                    </div>
                    <!-- end content-->
                </div>
                <!--  end card  -->
            </div>
            <!-- end col-md-12 -->
        </div>
        <!-- end row -->
    </div>
</div>



<div class="modal fade" id="myModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
  
        <div class="modal-header">
      
            <div class="row" style="width: 100%;">
              <div class="col-md-12">
                <h3>
                  <b>Users wanted this product:</b>
                </h3> 
                <hr>
                 
              </div>
  
              <hr>
            </div>
         
        </div>
  
        <div class="modal-body">

        <div *ngIf="uswerwonted.length === 0">
            <div class="alert alert-warning" role="alert">
                <div class="row">
                    <div class="col-md-12" style="display: inherit;">
                        <span class="material-icons">warning</span> &nbsp; <span>There is no users wanted this product</span> 
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="uswerwonted.length > 0">
            <div *ngFor="let item of uswerwonted">
                <div class="row">
                  <div class="col-md-12">
                      <button class="btn btn-link btn-just-icon">
                          <i class="material-icons">person</i>
                      </button> &nbsp;
                      <span>{{item.email}}</span><hr>
                  </div>
                </div>
            </div>
        </div>
  
  
          <br><br>
          <div class="row">
            <div class="col-md-6">
  
              <button type="button" class="btn btn-default btn-md" (click)="closeModal()">
                Close
              </button> 
  
            </div>
          </div>
          
        </div>
  
      </div>
    </div>
  </div>

<div class="modal fade" id="myModalHotDeal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-md" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h3> Hot Deal </h3>
        <button class="close" (click)="closeHotDealModal(0)"><span aria-hidden="true">&times;</span></button>
      </div>

      <div class="modal-body">
        <form #f="ngForm">
            <hr style="height:2px;border-width:0;color:gray;background-color:gray"> 
          <!--<div class="row">
            <div class="col-md-12">
              <label>Percentage:</label>
              <input type="number" class="form-control" name="percentage" [(ngModel)]="percentage" style="text-align: right;" required>
              <div class="input-group-prepend">
                <span class="input-group-text">
                    <i class="fa fa-percent" aria-hidden="true"></i>
                </span>
               </div>
            </div>
          </div>-->
          <div class="row">
            <div class="col-md-4">
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="bmd-label-floating text-center">Percentage</label>
                <span class="bmd-form-group">
                  <div class="input-group">
                    <input type="number" class="form-control" name="percentage" [(ngModel)]="percentage" style="text-align: center;" required>
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-percent" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary btn-md" (click)="closeHotDealModal(1)" [disabled]="!f.valid || percentage === 0">
          Save
        </button>
      </div>

    </div>
  </div>
</div>